import * as React from 'react'
import Helmet from 'react-helmet'

const SEO = ({
  lang,
  title,
  titleTemplate,
  description,
  canonical,
  robots,
  schema,
}) => (
  <Helmet
    htmlAttributes={{ lang }}
    titleTemplate={titleTemplate && titleTemplate}
  >
    <title>{title}</title>
    <meta name="description" content={description} />
    <meta name="robots" content={robots} />
    {canonical && <link rel="canonical" href={canonical} />}
    {schema &&
      schema.map((json) => (
        <script key={title} type="application/ld+json">
          {json}
        </script>
      ))}
  </Helmet>
)

export default SEO
